import { gql } from '@apollo/client';

export const DOWNLOAD_DELIVERY_TASK_TRACKING_NUMBERS = gql`
  mutation DownloadDeliveryTaskTrackingNumbers($taskId: Long!, $warehouseId: Long) {
    downloadDeliveryTaskTrackingNumbers(taskId: $taskId, warehouseId: $warehouseId)
  }
`;
